

<template>
  <v-layout wrap justify-center>
     <ServerError v-if="ServerError"/>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-flex xs12 pb-lg-12 pb-5 v-if="beekeeperData.coverImage == null">
      <v-img
        width="100%"
        height="400px"
        src="../../../assets/images/slider1.png"
        class="align-center"
      >
      </v-img>
    </v-flex>
    <v-flex xs12 pb-lg-12 pb-5 v-else>
      <v-img
        width="100%"
        height="400px"
        :src="mediaURL + beekeeperData.coverImage"
        class="align-center"
      >
      </v-img>
    </v-flex>
    <v-flex xs12 class="head" text-center>
      {{ beekeeperData.displayName }}</v-flex
    >
    <v-flex xs10  pb-lg-3 >
      <v-layout wrap justify-center text-center>
        <!-- <v-flex text-right align-self-end class="clr"> </v-flex> -->
        <v-flex md2 lg2 align-self-center >
          <v-rating
          color="yellow"
          background-color="yellow"
           readonly v-model="beekeeperData.rating" small> </v-rating>
        </v-flex>
        <!-- <v-flex text-left align-self-center class="clr"> {{ beekeeperData.rating }} </v-flex> -->
      </v-layout>
    </v-flex>
    <v-flex 
      xs11
      md10
      pt-4
      lg7
      text-center
      
      class="clr RR"
    >
      {{ beekeeperData.description }}
    </v-flex>
    <v-flex xs12 md12 pt-16 pb-2>
      <v-layout wrap px-lg-10 px-xl-16 px-3 >
        <v-flex xs12 md5 pl-lg-6>
          <iframe v-if="videoType == 'file'"
            height="300"
            :src="mediaURL +  splitUrl"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            width="100%"
          ></iframe>
          <iframe v-else
            height="300"
            :src="splitUrl"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            width="100%"
          ></iframe>
        </v-flex>
        <v-flex xs12 md7 pr-lg-8 >
          <v-layout wrap pl-md-12>
            <v-flex xs12 class="subhead" style="color: black;"  pb-3  >
              {{ beekeeperData.heading }}
            </v-flex>
            <v-flex xs12 lg10 pb-2 class="RR">
              {{ beekeeperData.videoDescription }}
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 v-if="products.length > 0" >
      <v-layout wrap justify-center>
        <v-flex xs12 text-center class="head">Our Products </v-flex>
        <!-- <v-flex pr-12 xs5 md5 text-right>
          <v-layout wrap text-right>
            <v-flex class="clr RB" pt-3 pt-lg-0> FILTER</v-flex>
            <v-flex xs2> <v-select solo flat dense></v-select></v-flex>
          </v-layout>
        </v-flex> -->
      </v-layout>
    </v-flex>
    <v-flex xs12 md11 >
      <v-layout wrap  pb-3>
        <v-flex sm6 md4 lg3  v-for="(item, i) in products" :key="i" >
          <v-card flat >
            <v-layout wrap justify-center text-center pr-3 py-6 >
              <v-flex xs12 pb-2>
                <v-img
                  v-if="item.photos.length < 0"
                  max-height="400"
                  src="../../../assets/images/blankImage.jpg"
                >
                </v-img>
                <v-img v-else max-height="500" :src="mediaURL + item.photos[0]">
                </v-img>
              </v-flex>
              <v-flex style="font-family: robotobold" xs12>
                {{ item.productName }}
              </v-flex>
              <v-flex xs12 pt-1>
                <span style="font-weight: bold">{{ item.price }} </span>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md12 lg11 pb-12 px-2>
      <v-card color="#FAFAFA" tile>
        <v-layout wrap px-3 py-4 pa-sm-12>
          <v-flex xs12 class="RM clr"> GET IN TOUCH WITH US </v-flex>
          <v-flex xs12 class="subhead" style="color: black"
            >{{ beekeeperData.displayName }}
          </v-flex>
          <v-flex xs12 md6>
            <v-layout wrap>
              <v-flex xs12 py-2>
                <span><v-icon>mdi-account-outline</v-icon></span
                ><span style="margin-left: 1%" class="RR">{{
                  beekeeperData.name
                }}</span>
              </v-flex>
              <v-flex xs12 py-2>
                <span><v-icon>mdi-phone-outline</v-icon></span>
                <span class="RR" style="margin-left: 1%">{{
                  beekeeperData.phone
                }}</span>
              </v-flex>
              <v-flex xs12 py-2>
                <span><v-icon>mdi-at</v-icon></span>
                <span class="RR" style="margin-left: 1%">{{
                  beekeeperData.email
                }}</span>
              </v-flex>
              <v-flex xs12 sm6 py-2>
                <span><v-icon>mdi-map-marker-outline</v-icon></span>
                <span class="RR" style="margin-left: 1%">{{
                  beekeeperData.address
                }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6 md6  text-center>
            <div class="RM clr">
              NO. OF<br />
              APIRIES
            </div>
            <div class="head">{{ beekeeperData.apiaryCount }}</div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex xs12 text-center class="head" v-if="hiveGallery.length > 0">Hive Gallery </v-flex>
    <v-flex px-2 xs12 v-if="hiveGallery.length > 0" pb-12 pt-5>
      <OwlCarousel :nav="true" :dots="false" :responsive="owlResponsive">
        <template v-for="(item, i) in hiveGallery">
          <v-layout wrap :key="i">
            <v-flex px-md-1 px-lg-3 pl-sm-2 px-xs-0>
              <v-card tile elevation="0">
                <v-img height="300px" 
                cover :src="mediaURL + item"> 
                   <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color=" #FDAC53"
                ></v-progress-circular>
              </v-row>
            </template>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </template>
      </OwlCarousel>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      ServerError:false,
      appLoading:false,
      id: "",
      trends: ["1", "3", "5", "7", "8", "9", "10", "11", "12", "12"],
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 3, nav: false },
        960: { items: 3, nav: false },
        1264: { items: 4, nav: false },
      },
      items: ["f2", "f1", "f3", "f2", "f1", "f3", "f2", "f1", "f3"],
      beekeeperData: [],
      products: [],
      hiveGallery: [],
      splitUrl:"",
      videoType:"",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading =true;
      axios({
        method: "get",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          this.beekeeperData = response.data.data.sellerProfileId;
          this.id = response.data.data.sellerProfileId.uid;
          
    this.getProducts();
          this.hiveGallery = response.data.data.sellerProfileId.hiveGallery;
          this.videoType = response.data.data.sellerProfileId.videoType
        
          if(response.data.data.sellerProfileId.videoUrl)
          {
            this.cutVideo(response.data.data.sellerProfileId.videoUrl)
          }
          if(response.data.data.sellerProfileId.video)
          {
           this.splitUrl = response.data.data.sellerProfileId.video
          }
          console.log("the hive gallery is =", this.hiveGallery);
          console.log(this.id);
        } else {
          console.log("beekeeperdara is not avilable");
        }
        this.appLoading =false
      })
       .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getProducts() {
      axios({
        method: "post",
        url: "/product/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data:
        {
          uid:this.id
        } 
      }).then((response) => {
        if (response.data.status) {
          this.products = response.data.data;
          console.log("theproducts is =", this.products);
        }
        else
        {
          console.log("there is nothig is in the products")
        }
       
      })
       .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    cutVideo(eve) {
      let b = "https://www.youtube.com/embed/";
      var em = eve.replace("https://www.youtube.com/watch?v=", b);
      em = eve.replace("https://youtu.be/", b);
      this.splitUrl = em;
    },
  },
};
</script>